<template lang="pug">
.units
  //- Barra de navegación
  van-nav-bar(:title="$t('units.title')")
    van-icon(name="menu" slot="left" @click="openSidenav")

  //- Sección principal
  .main(v-if="installations")

    //- Listado de instalaciones
    .units__installations(
      v-for="(installation, installationKey) in installations"
      :key="installationKey")

      //- Fila de instalación
      .units__installations__bar(
        @click="showManageInstallations(installationKey)")
        .units__installations__name {{ installation.name }}
        .units__installations__action
          van-icon(name="right")

      //- Fila de dispositivo
      .units__device__bar(
        v-for="(device, mac) in installation.devices"
        :key="mac"
        @click="showManageDevices(installationKey, mac)")
        .units__device__name
          van-icon.media__figure(:name="GetDeviceIcon(device)")
          | {{ device.name}}
        .units__device__action
          van-icon(name="right")


    //- Mensaje indicando que solo pueden verse las unidades en las que el usuario es avanzado
    .units__message {{ $t('units.advancedUser') }}

  //- Botón de enlace a la vista añadir dispositivo
  .button-bottom-group(v-if="installations && isMobile")
    router-link.button-bottom(to="/main/addUnit") {{ $t('units.addUnit') }}

  //- Mensaje cuando no hay ninguna instalación
  .padding(v-if="!installations")
    img.addUnit__img(src="@/assets/img/addUnitBluetooth.png")

    .addUnit__message.margin-double-bottom.margin-double-top
      .addUnit__message__title {{ $t('home.empty.title') }}
      | {{ isMobile ? $t('home.empty.message') : '' }}

    router-link.van-button.van-button--primary.van-button--large(
      v-if="isMobile"
      to="/main/addUnit")
      | {{ $t('sidenav.addUnit') }}

  //- Modal para editar Instalaciones
  van-popup.van-popup--full(
    v-model="openManageInstallations"
    position="right"
    :overlay="false")

    ManageInstallations(
      v-if="openManageInstallations"
      :installationID="installationID"
      @editInstallation="editInstallation"
      @deleteInstallation="deleteInstallation"
      @close="hideManageInstallations")

  //- Modal para editar Dispositivos
  van-popup.van-popup--full(
    v-model="openManageDevices"
    position="right"
    :overlay="false")

    ManageDevices(
      v-if="openManageDevices"
      :mac="mac"
      :installationID="installationID"
      @editDevice="editDevice"
      @deleteDevice="deleteDevice"
      @close="hideManageDevices")
</template>

<script>
import i18n from '@/locales/i18n';
import ManageInstallations from '@/components/Units/ManageInstallations.vue';
import ManageDevices from '@/components/Units/ManageDevices.vue';
import GetDeviceIcon from '@/mixins/GetDeviceIcon.mixin';
import { mapGetters, mapActions } from 'vuex';
import { IS_MOBILE } from '@/app.config';

export default {
  components: { ManageInstallations, ManageDevices },
  mixins: [GetDeviceIcon],
  data() {
    return {
      mac: '',
      installationID: '',
      openManageInstallations: false,
      openManageDevices: false,
      isMobile: IS_MOBILE,
    };
  },
  computed: {
    ...mapGetters({
      getAdvancedInstallations: 'unitsModule/getAdvancedInstallations',
    }),

    /**
     * Listado con todas las instalaciones
     *
     * @return {Array[Installation]} - Listado de instalaciones
     */
    installations() {
      return this.getAdvancedInstallations();
    },
  },
  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    /**
     * Muestra el modal para editar una instalación
     */
    showManageInstallations(installationID) {
      this.installationID = installationID;
      this.openManageInstallations = true;
    },

    /**
     * Oculta el modal para editar una instalación
     */
    hideManageInstallations() {
      this.installationID = '';
      this.openManageInstallations = false;
    },

    /**
     * Confirma los cambios de una instalación y cierra el modal
     */
    editInstallation() {
      this.$toast.success(i18n.t('manageUnit.addGroupSuccess'));
      this.hideManageInstallations();
    },

    /**
     * Confirma la eliminación de una instalación y cierra el modal
     */
    deleteInstallation() {
      this.$toast.success(i18n.t('manageUnit.deleteGroupSuccess'));
      this.hideManageInstallations();
    },

    /**
     * Muestra el modal para editar un dispositivo
     */
    showManageDevices(installationID, mac) {
      this.mac = mac;
      this.installationID = installationID;
      this.openManageDevices = true;
    },

    /**
     * Oculta el modal para editar un dispositivo
     */
    hideManageDevices() {
      this.mac = '';
      this.installationID = '';
      this.openManageDevices = false;
    },

    /**
     * Confirma los cambios de un dispositivo y cierra el modal
     */
    editDevice() {
      this.$toast.success(i18n.t('manageUnit.addGroupSuccess'));
      this.hideManageDevices();
    },

    /**
     * Confirma la eliminación de un dispositivo y cierra el modal
     */
    deleteDevice() {
      this.$toast.success(i18n.t('manageUnit.deleteUnitSuccess'));
      this.hideManageDevices();
    },
  },
};
</script>
